import { render, staticRenderFns } from "./PageFeaturesSlider.vue?vue&type=template&id=a9947fae&scoped=true"
import script from "./PageFeaturesSlider.vue?vue&type=script&lang=js"
export * from "./PageFeaturesSlider.vue?vue&type=script&lang=js"
import style0 from "./PageFeaturesSlider.vue?vue&type=style&index=0&id=a9947fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9947fae",
  null
  
)

export default component.exports